module.exports = __webpack_public_path__ + "img/menu-pets.a620c25.svg";